// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"686":"1c20844e","858":"67b9715d"}[chunkId] + ".chunk.js";
};